// src/pages/Api.js
import React from 'react';

function Api() {
  return (
    <div>
      <h2>API Reference</h2>
      <p>Complete API documentation can be found here.</p>
    </div>
  );
}

export default Api;
